let entrypoint = process.env.REACT_APP_API_ENTRYPOINT;
let appUrl = process.env.REACT_APP_REVIEWS_ENTRYPOINT;

export const ENTRYPOINT = entrypoint;
export const APP_URL = appUrl;